export interface HelpPageData {
  illustKey: string;
  descKey: string;
}

export const HELP_PAGES: HelpPageData[] = [
  {
    illustKey: "help-modal-0",
    descKey: "help.page_0.desc",
  },
  {
    illustKey: "help-modal-1",
    descKey: "help.page_1.desc",
  },
  {
    illustKey: "help-modal-2",
    descKey: "help.page_2.desc",
  },
  {
    illustKey: "help-modal-3",
    descKey: "help.page_3.desc",
  },
  {
    illustKey: "help-modal-4",
    descKey: "help.page_4.desc",
  },
];
